module.exports = __webpack_public_path__ + "assets/05160d444142d4c1a5e46698e3873e73.svg";